module.exports = __webpack_public_path__ + "static/rakesh-mahto-c1290d0d567ea6c57233313fb76386a1.jpg";